// import libs
import { React } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { LoginPage } from "../pages/Auth";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import { DashboardPage } from "../pages/Dashboard/DashboardPage";
import { EditProfilePage } from "../pages/EditProfile/EditProfilePage";

import { PageNotFound } from "../common/components";
import NewsRoutes from "../pages/Masters/News/NewsRoutes";
import ProductRoutes from "../pages/Masters/Product/ProductRoutes";
import ManualRoutes from "../pages/Masters/Manual/ManualRoutes";
import BrochureRoutes from "../pages/Masters/Brochure/BrochureRoutes";
import TutorialRoutes from "../pages/Masters/Tutorial/TutorialRoutes";
import CareerRoutes from "../pages/Masters/Career/CareerRoutes";
import TheMaticDemoRoutes from "../pages/Masters/TheMaticDemo/TheMaticDemoRoutes";
import ContactRoutes from "../pages/Masters/Contact/ContactRoutes";
import SoftwareRoutes from "../pages/Masters/Software/SoftwareRoutes";
import NewsLetterRoutes from "../pages/Masters/NewsLetter/NewsLetterRoutes";
import TopicRoutes from "../pages/Masters/Topic/TopicRoutes";
import NewsLetterMailRoutes from "../pages/Masters/NewsLetterMail/NewsLetterMailRoutes";
import TopicItemRoutes from "../pages/Masters/TopicItem/TopicItemRoutes";
import QuoteRoutes from "../pages/Masters/Quote/QuoteRoutes";
import FeaturesRoutes from "../pages/Settings/Features/FeaturesRoutes";
import OurproductRoutes from "../pages/Settings/Ourproduct/OurproductRoutes";
import TestimonialRoutes from "../pages/Settings/Testimonial/TestimonialRoutes";
import GeneralsettingRoutes from "../pages/Settings/Generalsetting/GeneralsettingRoutes"
import BlogRoutes from "../pages/Masters/Blog/BlogRoutes"

const PagesRoutes = () => {
  return (
    <Router>
      <Helmet>
        <title>GUI View Admin</title>
        <meta name="og:title" content={"guiview"} />
        <meta name="title" content={"guiview"} />
        <meta name="description" content={""} />
        <meta name="og:description" content={""} />
      </Helmet>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route exact path="/" element={<LoginPage />} />
          <Route exact path="/login" element={<LoginPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route exact path="/dashboard" element={<DashboardPage />} />
          <Route exact path="/edit-profile" element={<EditProfilePage />} />
          {/* News Routes */}
          <Route path="/news/*" element={<NewsRoutes />} />
          {/* Product Routes */}
          <Route path="/product/*" element={<ProductRoutes />} />
          {/* Manual Routes */}
          <Route path="/manual/*" element={<ManualRoutes />} />
          {/* Brochure Routes */}
          <Route path="/brochure/*" element={<BrochureRoutes />} />
          {/* Tutorial Routes */}
          <Route path="/tutorial/*" element={<TutorialRoutes />} />
          {/* Career Routes */}
          <Route path="/career/*" element={<CareerRoutes />} />
          {/* TheMaticDemo Routes */}
          <Route path="/thematicdemo/*" element={<TheMaticDemoRoutes />} />
          {/* Contact Routes */}
          <Route path="/contact/*" element={<ContactRoutes />} />
          {/* Software Routes */}
          <Route path="/software/*" element={<SoftwareRoutes />} />
          {/* NewsLetter Routes */}
          <Route path="/newsletter/*" element={<NewsLetterRoutes />} />
          {/* Topic Routes */}
          <Route path="/topic/*" element={<TopicRoutes />} />
          {/* News Letter Mail Routes */}
          <Route path="/newslettermail/*" element={<NewsLetterMailRoutes />} />
          <Route path="/topicitem/*" element={<TopicItemRoutes />} />
          <Route path="/quote/*" element={<QuoteRoutes />} />
          <Route path="/features/*" element={<FeaturesRoutes />} />
          <Route path="/our-product/*" element={<OurproductRoutes />} />
          <Route path="/testimonial/*" element={<TestimonialRoutes />} />
          <Route path="/general-setting/*" element={<GeneralsettingRoutes />} />
          {/* Blog Routes */}
          <Route path="/blog/*" element={<BlogRoutes />} />
        </Route>
        <Route>
          <Route path="*" element={<PageNotFound />} from="admin" />
        </Route>
      </Routes>
    </Router>
  );
};

export default PagesRoutes;
